import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CerrixDialogComponent } from '../cerrix-dialog/cerrix-dialog.component';
import { CerrixDialogInterface } from '../models/dialog/cerrix-dialog.model';

@Injectable({
  providedIn: 'root',
})
export class CerrixDialogService {
  private readonly _dialog = inject(MatDialog);

  baseConfig: MatDialogConfig<CerrixDialogInterface> = {
    minWidth: '320px',
    minHeight: '240px',
  };

  public openDialog(config: MatDialogConfig<CerrixDialogInterface>) {
    let _config = this.createDialogConfig(config);
    return this._dialog.open(CerrixDialogComponent, _config);
  }

  public openSuccessDialog(config: MatDialogConfig<CerrixDialogInterface>) {
    let _config = this.createDialogConfig(config);
    if (_config.data !== undefined) {
      _config.data.status = 'success';
    }
    return this.openDialog(_config);
  }

  public openWarningConfirmDialog(
    config: MatDialogConfig<CerrixDialogInterface>
  ) {
    let _config = this.createDialogConfig(config);
    if (_config.data !== undefined) {
      _config.data.icon = 'warning';
      _config.data.iconClass = 'material-symbols-outlined warning';
    }
    return this.openDialog(_config);
  }

  public confirmDialog(title: string, message: string): Observable<boolean> {
    return new Observable<boolean>(observer => {
      let _config = this.createDialogConfig({
        data: {
          title: title,
          message: message,
          icon: 'warning',
          iconClass: 'material-symbols-outlined warning',
          positiveButton: {
            text: `Confirm`,
            buttonClass: 'warning',
            onAction: () => {
              observer.next(true);
              observer.complete();

              return true;
            },
          },
          negativeButton: {
            text: 'Cancel',
            onAction: () => {
              observer.next(false);
              observer.complete();
              return true;
            },
          },
        },
      });

      this.openDialog(_config)
        .afterClosed()
        .subscribe(() => {
          observer.next(false);
          observer.complete();
        });
    });
  }

  private createDialogConfig(
    config: MatDialogConfig<CerrixDialogInterface>
  ): MatDialogConfig<any> {
    let dialogConfig = {
      ...this.baseConfig,
      ...config,
      data: {
        ...this.baseConfig.data,
        ...config.data,
      },
    };

    return dialogConfig;
  }
}
